import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, from } from 'rxjs';
import { delay } from 'rxjs/operators';
import { GlobalService } from 'src/app/_services/global.service';
import { HashService } from 'src/app/_services/hash.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { JdData } from 'src/app/common-interfaces-classes/JdData';
import { TextExtractResponse } from 'src/app/common-interfaces-classes/TextEtractResponse';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { GenAiJdSearchComponent } from 'src/app/gen-ai-jd-search/gen-ai-jd-search.component';
import { JdDataService } from 'src/app/jd-data.service';
import { SimilarCandidateFilterComponent } from 'src/app/similar-candidate-filter/similar-candidate-filter.component';
import { Location } from '@angular/common';
import * as _ from 'underscore';



export interface jdParserResponse {
  status: string;
  data: {
    preferredskills?: string[];
    mandatoryskills?: string[];
    educationaldegrees?: string[];
    industries: string[];
    jobtitles: string[];
    locations: string[];        // Assuming string array, could be expanded if structure known
    yearsofexperience: {
      min: number | null;
      max: number | null;
    };
    companies: string[];
    fieldofstudy: string[];
    schools: string[];
    suggestedjobtitle: string[];
    tools: string[];
    continents: string[];
    exactlocationmatch: string | null;
    normalizedlocations: any[] | null;
  };
}

@Component({
    selector: 'app-jd-search',
    templateUrl: './jd-search.component.html',
    styleUrls: ['./jd-search.component.scss'],
    standalone: false
})
export class JdSearchComponent implements OnInit {

  isUploadedFileCorrect = false;
  incorrectFileFormat = false;
  specialCharaterError = false;
  fileSizeLimitExceeded = false;
  jdDataLoading = false;
  textExtractionError = false;

  uploadedFilename: string;
  uploadedFile = null;

  enteredJobDescription: string;

  textExtractionErrorMessage: string;

  showHistoryViewAll: any;
  showSavedHistoryViewAll: any;
  historySubject = new Subject<any>();
  savedHistorySubject = new Subject<any>();

  isTalentInsightsModule: boolean = false

  constructor(
    private searchtoolbox: SearchtoolboxService, public modalService: NgbModal,
    private hashService: HashService, private jdDataService: JdDataService,
    private router: Router, private activatedRoute: ActivatedRoute, private personSearchService: PersonSearchService,
    private location: Location, private route: ActivatedRoute

  ) { }

  ngOnInit() {
    if (this.router.url.includes('talentpool-insights')) {
      this.isTalentInsightsModule = true;
    }
  }

  get isComingFromJD() {
    return this.jdDataService.isComingFromJobDescription;
  }

  resetFormFields() {
    this.incorrectFileFormat = false;
    this.specialCharaterError = false;
    this.isUploadedFileCorrect = false;
    this.uploadedFilename = null;
    this.fileSizeLimitExceeded = false;
    this.enteredJobDescription = "";
  }

  uploadFile(event) {
    this.resetFormFields();
    const file: File = event.target.files[0];
    this.uploadedFile = GlobalService.validateAndSanitizeFile(file);
    this.validateInputFile();

    if (this.uploadedFile && !this.specialCharaterError && !this.incorrectFileFormat && !this.fileSizeLimitExceeded) {
      this.isUploadedFileCorrect = true;
      this.uploadedFilename = file.name;
      this.jdDataLoading = true;
      this.searchtoolbox.documentToText(this.uploadedFile).subscribe((response: TextExtractResponse) => {
        this.jdDataLoading = false;
        this.processTextractResponse(response);
      }, () => this.jdDataLoading = false);
    }
  }

  private validateInputFile() {
    const validFileExtensions = ['doc', 'docx', 'pdf', 'txt', 'odt'];
    const uploadedFileExtension = this.uploadedFile.name.split('.').pop();

    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
    }
    // Verify file size (File size cannot exceed 5 MB)
    if (this.uploadedFile.size > 5242880) {
      this.fileSizeLimitExceeded = true;
    }
  }

  private processTextractResponse(response: TextExtractResponse) {
    if (response.status === "success") {
      this.enteredJobDescription = response.text;
      this.textExtractionError = false;
      this.textExtractionErrorMessage = null;
    }
    else if (response.status === "failure") {
      this.textExtractionError = true;
      this.textExtractionError = true;
      this.textExtractionErrorMessage = response.message;
    }
  }

  get isDescriptionEmpty() {
    return !this.enteredJobDescription || this.enteredJobDescription?.toString()?.trim()?.length === 0;
  }

  addJobDescription() {
    if (this.isDescriptionEmpty) return;
    this.getJDKeywordsAI(this.enteredJobDescription.toString().trim());
  }

  private getJDKeywordsAI(description: string = null) {
    const modalRef = this.modalService.open(
      GenAiJdSearchComponent,
      { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false }
    );
    const modalInstance: GenAiJdSearchComponent = modalRef.componentInstance;
    modalInstance.description = description;

    const modalResult$ = from(modalRef.result);
    modalResult$.subscribe((response: jdParserResponse) => {
      if (response) {
        const convertedResponse = this.convertJdResponse(response);
        this.jdDataService.setJdDescription(description);
        if(this.isTalentInsightsModule) {
        const convertedResponse = this.convertJdResponse(response);
        this.jdDataService.emitJDDataEvent(convertedResponse);
        } else {
          this.openSimilarCandidateFilters(convertedResponse, true);
        }
      }
    }
    )
      const uniqueHash = this.hashService.generateUniqueHash();
    if(this.isTalentInsightsModule){
      // For talent-insights jd
      this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: {
            type: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION,
            uniqueHash
          },
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        }
      );
    }
  }

  checkHistory(event, saveMode: boolean = false) {
    if (event === 'REFRESH') {
      this.savedHistorySubject.next(event);
    } else {
      this[saveMode ? 'showSavedHistoryViewAll' : 'showHistoryViewAll'] = event;
    }
  }

  viewAllHistory(saveMode: boolean = false) {
    this[saveMode ? 'savedHistorySubject' : 'historySubject'].next(undefined as any);
  }

  /**
   * Used to convert new Jd parser (Groq) in the form of preivously used JD parser(openAi)
   * @param jdResp
   * @returns
   */
  convertJdResponse(jdResp: jdParserResponse): JdData {
    if (!jdResp || jdResp.status !== 'success' || !jdResp.data) {
      throw new Error("Invalid Jd parse response format.");
    }

    const data = jdResp.data;
    let mergeJobTitles = data?.jobtitles?.slice(1) || [];
    mergeJobTitles = mergeJobTitles.concat(mergeJobTitles, data?.suggestedjobtitle || [])
    const jdData = {
      "Job Title": data.jobtitles?.[0] || null,
      "Suggested job Title": mergeJobTitles,
      "Preferred Skills": data.preferredskills || [],
      "Tools": data.tools.length ? data.tools : null,
      "Years of experience": {
        "minimum experience": data.yearsofexperience?.min ?? null,
        "maximum experience": data.yearsofexperience?.max ?? null
      },
      "Relevant Year of experience": {
        "minimum experience": data.yearsofexperience?.min ?? null,
        "maximum experience": data.yearsofexperience?.max ?? null
      },
      "Industry": data.industries || [],
      "Location": {
        "city": null,
        "state": null,
        "country": null,
        "continent": data.continents?.[0] || null
      },
      "Target Company": data.companies.length ? data.companies : [],
      "Degree": data.educationaldegrees || [],
      "Field of study": data.fieldofstudy || [],
      "School": data.schools.length ? data.schools : null,
      "Mandatory Skills": data.mandatoryskills || [],
      "exactLocationMatch": data.exactlocationmatch || null,
      "normalizedlocations": data.normalizedlocations || [],
      "normalizedcontinents": data.normalizedlocations.map(loc => loc.continent) || []
    };
    return {
      status: 'success',
      jdData: jdData
    }
  }

  private openSimilarCandidateFilters(jdResponse: JdData, firstLoad = false) {
   const similarobj = firstLoad ? this.jdDataService.getSimilarObj(jdResponse) : this.jdDataService.jdDataFromSession;
   console.log(similarobj, "check continent");

    this.personSearchService.passsimilarcandidatesdata({ data: similarobj, calledfrom: this.isComingFromJD ? GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION : GeneralConstants.REDIRECT_SOURCES.NL_SEARCH });
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        type: 'job-description',
      },
      queryParamsHandling: 'merge'
    });
    if (similarobj?.jobtitle?.length > 0) {
      this.modalService.dismissAll();
      this.personSearchService.passsimilarcandidatesdata(similarobj);
      this.jdDataService.emitjdDataForRedirect(similarobj);


      const uniqueHash = this.hashService.generateUniqueHash();
      if(this.isTalentInsightsModule) {
        this.jdDataService.emitJDRedirectEvent(similarobj)
           this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: {
            type: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION,
            uniqueHash
          },
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        }
      );

         } else {
      this.router.navigate(
        ['/person/search/listing'],
        {
          queryParams: {
            type: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION,
            uniqueHash
          },
        }
      );
    }

    } else {
      this.modalService.dismissAll();
      const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.calledFrom = "'job-description'";
      modalRef.componentInstance.disableDisableButton = firstLoad;
      modalRef.result.then((res) => {
        if (res.action == 'submit') {
          this.personSearchService.passsimilarcandidatesdata(res);
          this.jdDataService.emitjdDataForRedirect(res.data);
          const uniqueHash = this.hashService.generateUniqueHash();
 if(this.isTalentInsightsModule) {
          this.jdDataService.emitJDRedirectEvent(similarobj)

      this.router.navigate(
        ['/talentpool-insights'],
        {
          queryParams: {
            type: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION,
            uniqueHash
          },
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        }
      );

         } else {
          this.router.navigate(
            ['/person/search/listing'],
            {
              queryParams: {
                type: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION,
                uniqueHash
              },
            }
          );
        }
       } else if (res.action === 'close' && firstLoad) {
          this.location.back();
        }
      });



    }
  }
}
